import { Component, OnInit, ChangeDetectionStrategy, ViewChild } from '@angular/core';
import { FormControl, Validators, FormGroup, FormBuilder } from '@angular/forms';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatOption } from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { ChartOptions, ChartType, ChartDataSets } from 'chart.js';
import { Label } from 'ng2-charts';
import { ToastrService } from "ngx-toastr";
import { CommonService } from "../../core/service/common-service/common.service";
import { ExampleHeader } from './custom-header-cal/custom-header.component';

import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports
import { default as _rollupMoment, Moment } from 'moment';
import { ChartDialogComponent } from 'src/app/modal/chart-dialog/chart-dialog.component';
import { MatDialog } from '@angular/material';
import { ServiceBreakDialogComponent } from 'src/app/modal/service-break-dialog/service-break-dialog.component';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import {MatMonthView} from '@angular/material/datepicker';
import { element } from 'protractor';

const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'MMM/YYYY',
  },
  display: {
    dateInput: 'MMM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ]
})

export class DashboardComponent implements OnInit {

  @ViewChild('allSelectedService', { static: true }) private allSelectedService: MatOption;

  selectService: any;
  exampleHeader = ExampleHeader;
  date = new FormControl(moment());
  selectedDate: any;
  minDate: any = new Date();
  maxDate: any = new Date();
  spinner: boolean;
  filtersWorkshop: any = [];
  filtersCre: string[] = [];
  selectedWorkShop: string[] = [];
  userId: string;
  userInfo: any;
  selectedCre: string[] = [];
  serviceType:string = "";
  updateChart: boolean = false;
  updateChartCard: boolean = false;
  //line-char
  callCoverage: any = [];
  selectedCallCoverage: any = {};
  avgCall: any = [];
  selectedAvgCall: any = {};
  successReminder: any = [];
  selectedSuccessReminder: any = {};
  successVisit: any = [];
  selectedSuccessVisit: any = {};
  successNoShow: any = [];
  selectedSuccessNoShow: any = {};
  lostConversion: any = [];
  selectedLostConversion: any = {};
  overAllConversion: any = [];
  selectedOverAllConversion: any = {};
  bookingRate: any = [];
  selectedBookingRate: any = {};
  perCallConversion: any = [];
  selectedPerCallConversion: any = {};
  services: any = [
    {key: "1", value: "ECS - Early Care Service"},
    {key: "2", value: "FS - Free Service"},
    {key: "3", value: "PMS - Preventive Maintenance Service"},
    {key: "4", value: "Technical Campaign Order"},
    {key: "7", value: "Fault Code"},
    {key: "6", value: "Wheel Alignment"},
    {key: "8", value: "PMS BS-6"},
    {key: "9", value: "Running Repair"},
    {key: "10", value: "PBBI - Post Body Building Inspection"}
  ];
  //hr-bar
  allocated: any = {};
  attempted: any = {};
  notAttempted: any = {};
  contacted: any = {};
  notContacted: any = {};
  booking: any = {};
  converted: any = {};
  activeBooking: any = {};
  contactedNoService: any = {};
  contactedFollowup: any = {};
  connectedSystemClose: any = {};
  bookingFollowup: any = {};
  bookingNoService: any = {};
  bookingSystemClose: any = {};
  noResponse: any = {};
  busy: any = {};
  switchOff: any = {};
  invalid: any = {};
  others: any = {};
  followup: any = {};
  followup1: any = {};
  followup2: any = {};
  uniqueWorkshop: string[] = [];
  uniqueWorkshopCopy: string[] = [];
  uniqueWorkshopCard: string[] = [];
  uniqueWorkshopCardCopy: string[] = [];
  selectedDealer: any;
  selectedCardDealer: any;
  filtersCreCopy: string[] = [];
  selectedCreCode: any;
  dealerCode: string[] = [];
  dealerCodeCard: string[] = [];
  creCode: string[] = [];
  today: Date = new Date();
  toDate: Date;
  fromDate: Date;
  isDateRangeInvalid = false;
  selectAllService: boolean;
  availableDashboard:string[]=[];
  selectedDashboard:any


  bFollowup1: any = {};
  bFollowup2: any = {};
  bFollowup3: any = {};

  systemClose: any = {};
  noService: any = {};
  notConverted: any = {};
  noShow: any = {};

  //connected bar
  wrongOdo: any = {};
  alreadyService: any = {};
  vehicleSold: any = {};
  disPreviousSer: any = {};
  distanceDealer: any = {};
  disSales: any = {};
  contactedOthers: any = {};
  disInsurance: any = {};
  custNotInterested: any = {};
  dnd: any = {};

  //booking bar
  bWrongOdo: any = {};
  bAlreadyService: any = {};
  bVehicleSold: any = {};
  bDisPreviousSer: any = {};
  bDistanceDealer: any = {};
  bDisSales: any = {};
  bookingOthers: any = {};
  bDisInsurance: any = {};
  bCustNotInterested: any = {};
  bDnd: any = {};

  //follow-reason
  sameDay: any = {};
  eventual: any = {};

  //service-breakup
  allocatedServiceBreak: any[] = [];
  attemptedServiceBreak: any[] = [];
  connectedServiceBreak: any[] = [];
  bookingServiceBreak: any[] = [];
  AttemptedAchievement: number;
  ContactedAchievement: any;
  BookingsAchievement: any;
  selectedKpiCardWorkShop: string[] = [];
  minEndDate: any = new Date();


  //horizontalBarChart1 horizontalBar start
  public horizontalBarChart1Options: ChartOptions = {
    responsive: true,
    title: { display: false },
    tooltips: {
      enabled: false,
      mode: 'single',
      position: 'nearest',
      caretSize: 2,
      bodyAlign: 'center',
      titleAlign: 'center',
      titleFontSize: 11,
      titleFontStyle: 'normal',
      bodyFontSize: 11,
      bodyFontStyle: 'normal'
    },
    scales: {
      xAxes: [{
        display: false, ticks: {
          beginAtZero: true,
          fontSize: 11
        }
      }],
      yAxes: [{
        display: false, ticks: {
          beginAtZero: true,
          fontSize: 11
        }
      }],
    }
  };
  public horizontalBarChart1Labels: Label[] = ['Attempted'];
  public horizontalBarChartType: ChartType = 'horizontalBar';
  public horizontalBarChartLegend = false;
  public horizontalBarChartPlugins = [];
  public horizontalBarChart1Data: ChartDataSets[] = [];
  //horizontalBarChart1 horizontalBar end

  //horizontalBarChart2 horizontalBar start
  public horizontalBarChart2Labels: Label[] = ['Connected'];
  public horizontalBarChart2Options: ChartOptions = {
    responsive: true,
    title: { display: false },
    tooltips: {
      enabled: false,
      mode: 'single',
      position: 'nearest',
      caretSize: 2,
      bodyAlign: 'center',
      titleAlign: 'center',
      titleFontSize: 11,
      titleFontStyle: 'normal',
      bodyFontSize: 11,
      bodyFontStyle: 'normal'
    },
    scales: {
      xAxes: [{
        display: false, ticks: {
          beginAtZero: true,
          fontSize: 11
        }
      }],
      yAxes: [{
        display: false, ticks: {
          beginAtZero: true,
          fontSize: 11
        }
      }],
    }
  };
  public horizontalBarChart2Data: ChartDataSets[] = [];
  //horizontalBarChart2 horizontalBar end

  //horizontalBarChart3 horizontalBar start
  public horizontalBarChart3Labels: Label[] = ['Bookings'];
  public horizontalBarChart3Options: ChartOptions = {
    responsive: true,
    title: { display: false },
    tooltips: {
      enabled: false,
      mode: 'single',
      position: 'nearest',
      caretSize: 2,
      bodyAlign: 'center',
      titleAlign: 'center',
      titleFontSize: 11,
      titleFontStyle: 'normal',
      bodyFontSize: 11,
      bodyFontStyle: 'normal'
    },
    scales: {
      xAxes: [{
        display: false, ticks: {
          beginAtZero: true,
          fontSize: 11
        }
      }],
      yAxes: [{
        display: false, ticks: {
          beginAtZero: true,
          fontSize: 11
        }
      }],
    }
  };
  public horizontalBarChart3Data: ChartDataSets[] = [];
  //horizontalBarChart3 horizontalBar end

  //horizontalBarChart4 horizontalBar start
  public horizontalBarChart4Options: ChartOptions = {
    responsive: true,
    title: { display: false },
    tooltips: {
      enabled: true,
      mode: 'single',
      position: 'nearest',
      caretSize: 2,
      bodyAlign: 'center',
      titleAlign: 'center',
      displayColors: false,
      titleFontSize: 11,
      titleFontStyle: 'normal',
      bodyFontSize: 11,
      bodyFontStyle: 'normal'
    },
    scales: {
      xAxes: [{
        display: false, ticks: {
          beginAtZero: true,
          fontSize: 11
        }
      }],
      yAxes: [{
        display: true,
        gridLines: { display: false },
        scaleLabel: { display: true },
        ticks: {
          beginAtZero: true,
          fontSize: 11
        }
      }],
    }
  };
  public horizontalBarChart4Labels: Label[] = [
    'Wrong Odometer Prediction',
    "Already Serviced",
    "Vehicle Sold",
    "Dissatisfied With Previous Service",
    "Distance From Dealer Location",
    "Dissatisfaction With Sales",
    "Dissatisfaction With Insurance",
    "Other",
    "Customer Not Interested",
    "Do Not Call This Customer In Future"
  ];
  public horizontalBarChart4Data: ChartDataSets[] = [];
  //horizontalBarChart4 horizontalBar end
  public horizontalBarChart5Options: ChartOptions = {
    responsive: true,
    title: { display: false },
    tooltips: {
      enabled: true,
      mode: 'single',
      position: 'nearest',
      caretSize: 2,
      bodyAlign: 'center',
      titleAlign: 'center',
      displayColors: false,
      titleFontSize: 11,
      titleFontStyle: 'normal',
      bodyFontSize: 11,
      bodyFontStyle: 'normal'
    },
    scales: {
      xAxes: [{
        display: false, ticks: {
          beginAtZero: true,
          fontSize: 11
        }
      }],
      yAxes: [{
        display: true,
        gridLines: { display: false },
        scaleLabel: { display: true },
        ticks: {
          beginAtZero: true,
          fontSize: 11
        }
      }],
    }
  };
  public horizontalBarChart5Data: ChartDataSets[] = [];

  //horizontalBarChart6 horizontalBar start
  public horizontalBarChart6Options: ChartOptions = {
    responsive: true,
    title: { display: false },
    tooltips: {
      enabled: true,
      mode: 'single',
      position: 'nearest',
      caretSize: 2,
      bodyAlign: 'center',
      titleAlign: 'center',
      displayColors: false,
      titleFontSize: 11,
      titleFontStyle: 'normal',
      bodyFontSize: 11,
      bodyFontStyle: 'normal'
    },
    scales: {
      xAxes: [{
        display: false, ticks: {
          beginAtZero: true,
          fontSize: 11
        }
      }],
      yAxes: [{
        display: true,
        gridLines: { display: false },
        scaleLabel: { display: true },
        ticks: {
          beginAtZero: true,
          fontSize: 11
        }
      }],
    }
  };
  public horizontalBarChart6Labels: Label[] = [
    'Call Later',
    "Cancel Booking And Call Later",
  ];
  public horizontalBarChart6Data: ChartDataSets[] = [];
  //horizontalBarChart6 horizontalBar end

  //horizontalBarChart7 horizontalBar start
  public horizontalBarChart7Options: ChartOptions = {
    responsive: true,
    title: { display: false },
    tooltips: {
      enabled: true,
      mode: 'single',
      position: 'nearest',
      caretSize: 2,
      bodyAlign: 'center',
      titleAlign: 'center',
      displayColors: false,
      titleFontSize: 11,
      titleFontStyle: 'normal',
      bodyFontSize: 11,
      bodyFontStyle: 'normal'
    },
    scales: {
      xAxes: [{
        display: false, ticks: {
          beginAtZero: true,
          fontSize: 11
        }
      }],
      yAxes: [{
        display: true,
        gridLines: { display: false },
        scaleLabel: { display: true },
        ticks: {
          beginAtZero: true,
          fontSize: 11
        }
      }],
    }
  };
  public horizontalBarChart7Labels: Label[] = [
    'Follow Up',
    'Contact Fleet Manager',
  ];
  public horizontalBarChart7Data: ChartDataSets[] = [];
  //horizontalBarChart7 horizontalBar end

  //horizontalBarChart8 horizontalBar start
  public horizontalBarChart8Options: ChartOptions = {
    responsive: true,
    title: { display: false },
    tooltips: {
      enabled: true,
      mode: 'single',
      position: 'nearest',
      caretSize: 2,
      bodyAlign: 'center',
      titleAlign: 'center',
      displayColors: false,
      titleFontSize: 11,
      titleFontStyle: 'normal',
      bodyFontSize: 11,
      bodyFontStyle: 'normal'
    },
    scales: {
      xAxes: [{
        display: false, ticks: {
          beginAtZero: true,
          fontSize: 11
        }
      }],
      yAxes: [{
        display: true,
        gridLines: { display: false },
        scaleLabel: { display: true },
        ticks: {
          beginAtZero: true,
          fontSize: 11
        }
      }],
    }
  };
  public horizontalBarChart8Labels: Label[] = [
    'Call Later',
    'Contact Fleet Manager',
    'Cancel Booking'
  ];
  public horizontalBarChart8Data: ChartDataSets[] = [];
  //horizontalBarChart8 horizontalBar end

  //barChart1 VerticalBar start
  public barChart1Options: ChartOptions = {
    responsive: true,
    title: {
      display: true,
      text: 'Not Contacted Reason',
      position: 'top',
      fontSize: 13
    },
    tooltips: {
      enabled: true,
      mode: 'single',
      position: 'nearest',
      caretSize: 2,
      bodyAlign: 'center',
      titleAlign: 'center',
      displayColors: false,
      titleFontSize: 11,
      titleFontStyle: 'normal',
      bodyFontSize: 11,
      bodyFontStyle: 'normal'
    },
    scales: {
      xAxes: [{
        display: true,
        gridLines: {
          display: false,
        },
        scaleLabel: {
          display: true,
        },
        ticks: {
          beginAtZero: true,
          fontSize: 11
        }
      }],
      yAxes: [{
        display: false,
        ticks: {
          beginAtZero: true,
          fontSize: 11
        }
      }],
    }
  };
  public barChart1Labels: Label[] = ['No Response', 'Busy', 'Switched Off', 'Invalid No.', 'Others'];
  public barChart1Type: ChartType = 'bar';
  public barChart1Legend = false;
  public barChart1Plugins = [];
  public barChart1Data: ChartDataSets[] = [];
  //barChart1 VerticalBar end

  //barChart2 VerticalBar start
  public barChart2Options: ChartOptions = {
    responsive: true,
    title: {
      display: true,
      text: 'Conversion',
      position: 'top',
      fontSize: 13
    },
    tooltips: {
      enabled: true,
      mode: 'single',
      position: 'nearest',
      caretSize: 2,
      bodyAlign: 'center',
      titleAlign: 'center',
      displayColors: false,
      titleFontSize: 11,
      titleFontStyle: 'normal',
      bodyFontSize: 11,
      bodyFontStyle: 'normal'
    },
    scales: {
      xAxes: [{
        display: true,
        gridLines: {
          display: false,
        },
        scaleLabel: {
          display: true,
        },
        ticks: {
          beginAtZero: true,
          fontSize: 11
        }
      }],
      yAxes: [{
        display: false,
        ticks: {
          beginAtZero: true,
          fontSize: 11
        }
      }],
    }
  };
  public barChart2Labels: Label[] = ['Same Day', 'Eventual'];
  public barChart2Type: ChartType = 'bar';
  public barChart2Legend = false;
  public barChart2Plugins = [];
  public barChart2Data: ChartDataSets[] = [];
  //barChart2 VerticalBar end

  //barChart6 horizontalBar start
  public barChart6Options: ChartOptions = {
    responsive: true,
    title: {
      display: false
    },
    tooltips: {
      enabled: true,
      mode: 'single',
      position: 'nearest',
      caretSize: 2,
      bodyAlign: 'center',
      titleAlign: 'center',
      displayColors: false,
      titleFontSize: 11,
      titleFontStyle: 'normal',
      bodyFontSize: 11,
      bodyFontStyle: 'normal'
    },
    scales: {
      xAxes: [{
        display: false,
        ticks: {
          beginAtZero: true,
          max: 15,
          fontSize: 11
        }
      }],
      yAxes: [{
        display: true,
        gridLines: {
          display: false,
        },
        scaleLabel: {
          display: true,
        },
        ticks: {
          beginAtZero: true,
          max: 15,
          fontSize: 11
        }
      }],
    }
  };
  public barChart6Labels: Label[] = ['R1', 'R2', 'R3', 'R4'];
  public barChart6Type: ChartType = 'horizontalBar';
  public barChart6Legend = false;
  public barChart6Plugins = [];

  public barChart6Data: ChartDataSets[] = [
    {
      data: [15, 10, 12, 6],
      backgroundColor: 'rgb(87, 174, 239)',
      hoverBackgroundColor: 'rgb(87, 174, 239)',
      borderSkipped: 'chartArea',
      barPercentage: 0.5,
      barThickness: 12,
      maxBarThickness: 12,
      minBarLength: 2
    }
  ];
  //barChart6 horizontalBar end

  //lineChart1 VerticalBar start
  public lineChartOptions: ChartOptions = {
    responsive: true,
    legend: {
      display: false
    },
    title: {
      display: false
    },
    tooltips: {
      enabled: false
    },
    scales: {
      xAxes: [{
        display: true,
        gridLines: {
          display: false,
        },
        scaleLabel: {
          display: false,
        },
        ticks: {
          beginAtZero: true,
          display: false,
          max: 30,
          fontSize: 11
        }
      }],
      yAxes: [{
        display: false,
        ticks: {
          beginAtZero: true,
          max: 15,
          fontSize: 11
        }
      }],
    },
    elements: {
      line: {
        fill: false,
        tension: 0.000001,
      },
      point: {
        radius: 0
      }
    }
  };
  public lineChartLabels: Label[] = ['1', '2', '3', '4'];
  public lineChartType: ChartType = 'line';
  public lineChartLegend = false;
  public lineChartPlugins = [];

  public lineChart1Data: ChartDataSets[] = [
    {
      data: [2, 10, 5, 8],
      borderColor: 'black',
      backgroundColor: '#ffffff',
      hoverBackgroundColor: '#ffffff',
      borderWidth: 1
    }
  ];
  //lineChart1 VerticalBar end

  constructor(private commonService: CommonService, private toastr: ToastrService, public dialog: MatDialog, private router: Router, private datePipe: DatePipe, private fb: FormBuilder) { }

  ngOnInit() {
    this.setDefaultDates();
    this.availableDashboard=[]
    if(localStorage.getItem('roleId') == "1"){
      this.availableDashboard.push("Dashboard","Prs-Dashboard")
    }
    if(localStorage.getItem('roleId') == "12"){
      this.availableDashboard.push("Prs-Dashboard")
    }
    if(localStorage.getItem('roleId') == "15"){
      this.availableDashboard.push("Prs-Dashboard")
    }

    if (localStorage.getItem('userId') == null || localStorage.getItem('userId') == undefined) {
      this.router.navigate(['login']);
    }

    let userInfo = JSON.parse(localStorage.getItem('userInfo'));
    this.userInfo = userInfo[0];
    this.userId = localStorage.getItem("userId");
    this.filterDashboard();
    this.periodFilter();

    if (localStorage.getItem('workshops') == null || localStorage.getItem('workshops') == undefined) {
      this.getWorkshopDetails();
    }
    this.selectService = this.fb.group({
      selectServiceType: ['']
    });
  }

  /**
  * Name: getWorkshopDetails
  * purpose: To get CRE assigned workshop details
  */
  getWorkshopDetails() {
    this.spinner = true;
    this.commonService.getWorkshopDetails(this.userId)
      .subscribe(res => {
        if (res['responseCode'] == 0) {
          this.spinner = false;
          localStorage.setItem('workshops', JSON.stringify(res['responseData']));
        } else {
          this.spinner = false;
          //this.toastr.error(res['message'], "Error");
        }
      }, err => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
      });
  }

  chosenYearHandler(normalizedYear: Moment) {
    const ctrlValue = this.date.value;
    if(normalizedYear.year() == this.maxDate.getFullYear()) {
      ctrlValue.month(this.maxDate.getMonth());
    } else {
      ctrlValue.month(this.minDate.getMonth());
    }
    ctrlValue.year(normalizedYear.year());
    this.date.setValue(ctrlValue);
  }

  chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
    const ctrlValue = this.date.value;
    ctrlValue.month(normalizedMonth.month());
    ctrlValue.year(normalizedMonth.year());
    this.date.setValue(ctrlValue);
    datepicker.close();
  }

  reset() {
    this.selectedCre = [];
    this.selectedWorkShop = [];
    this.serviceType = "";
    let date = moment(this.maxDate);
    this.date.setValue(date);
    this.selectService.setValue({selectServiceType:''});
    this.setDefaultDates();
    this.isDateRangeInvalid = false;
    this.getDashboardKpi();
  }

  getChart(chartKpi: any) {
    this.dialog.open(ChartDialogComponent, {
      width: '600px',
      data: { kpi: chartKpi }
    });
  }

  getServiceBreak(serviceBreakup: any) {
    this.dialog.open(ServiceBreakDialogComponent, {
      width: '400px',
      data: { serviceBreak: serviceBreakup }
    });
  }

  resetResponse() {
    this.followup1 = {};
    this.followup2 = {};
    //booking followup
    this.bFollowup1 = {};
    this.bFollowup2 = {};
    this.bFollowup3 = {};
    //conversion
    this.sameDay = {};
    this.eventual = {};
    //not connected reason
    this.noResponse = {};
    this.busy = {};
    this.switchOff = {};
    this.invalid = {};
    this.others = {};
    //connected mo service
    this.wrongOdo = {};
    this.alreadyService = {};
    this.vehicleSold = {};
    this.disPreviousSer = {};
    this.distanceDealer = {};
    this.disInsurance = {};
    this.disSales = {};
    this.contactedOthers = {};
    this.custNotInterested = {};
    this.dnd = {};
    //booking no service
    this.bWrongOdo = {};
    this.bAlreadyService = {};
    this.bVehicleSold = {};
    this.bDisPreviousSer = {};
    this.bDistanceDealer = {};
    this.bDisInsurance = {};
    this.bDisSales = {};
    this.bookingOthers = {};
    this.bCustNotInterested = {};
    this.bDnd = {};
    this.barChart1Data = [];
    this.barChart2Data = [];
    this.horizontalBarChart4Data = [];
    this.horizontalBarChart5Data = [];
    this.horizontalBarChart7Data = [];
    this.horizontalBarChart8Data = [];
  }

  resetKpiCard() {
    this.callCoverage = [];
    this.selectedCallCoverage = {};

    this.avgCall = [];
    this.selectedAvgCall = {};

    this.successReminder = [];
    this.selectedSuccessReminder = {};

    this.successVisit = [];
    this.selectedSuccessVisit = {};

    this.successNoShow = [];
    this.selectedSuccessNoShow = {};

    this.lostConversion = [];
    this.selectedLostConversion = {};

    this.overAllConversion = [];
    this.selectedOverAllConversion = {};

    this.bookingRate = [];
    this.selectedBookingRate = {};

    this.perCallConversion = [];
    this.selectedPerCallConversion = {};
  }

  resetDashboard() {
    this.allocated = {};
    this.attempted = {};
    this.notAttempted = {};
    this.contacted = {};
    this.notContacted = {};
    this.booking = {};
    this.converted = {};
    this.activeBooking = {};
    this.contactedNoService = {};
    this.contactedFollowup = {};
    this.connectedSystemClose = {};
    this.bookingNoService = {};
    this.bookingFollowup = {};
    this.bookingSystemClose = {};
    this.horizontalBarChart1Data = [];
    this.horizontalBarChart2Data = [];
    this.horizontalBarChart3Data = [];
    this.horizontalBarChart7Data = [];
    this.horizontalBarChart4Data = [];
    this.barChart1Data = [];
  }

  /**
   * Name: getDashboardResponseKpi
   * purpose: To get service history
   */
  getDashboardResponseKpi(): void {
    this.spinner = true;
    this.updateChartCard = true;
    let selectedCre = '';
    this.selectedCre.forEach((element, index) => {
      if (index == 0) {
        selectedCre = element;
      } else {
        selectedCre = selectedCre + ',' + element;
      }
    });
    let selectedWorkShop = '';
    this.selectedWorkShop.forEach((element, index) => {
      if (index == 0) {
        selectedWorkShop = element.split(" - ")[0];
      } else {
        selectedWorkShop = selectedWorkShop + ',' + element.split(" - ")[0];
      }
    });

    let service = '';
    if(this.selectService.value.selectServiceType != ""){
      this.selectService.value.selectServiceType.forEach((element,index)=>{
        if(element == "0"){
          this.selectService.value.selectServiceType.splice(index,1);
        }
      });
      service = this.selectService.value.selectServiceType.toString();
    }

    const request = {
      "userId": this.userInfo.userId,
      "roleId": this.userInfo.roleId,
      "creId": selectedCre || '',
      "workshopCode": selectedWorkShop || '',
      "service": service ? service.toString() : '',
      "startDate": this.datePipe.transform(this.fromDate, "yyyy-MM-dd").toString(),
      "endDate": this.datePipe.transform(this.toDate, "yyyy-MM-dd").toString()
    };
    this.resetResponse();
    this.commonService.getDashboardResponseKpi(request).subscribe(
      res => {
        if (res["responseCode"] == 0) {
          this.selectedDate = this.datePipe.transform(this.date.value['_d'], "MMM yy");
          res["responseData"].forEach(kpi => {
            if (kpi.actualVal) {
              kpi.actualVal = Math.round(kpi.actualVal * 100 + Number.EPSILON) / 100;
            }
            if (kpi.growthRate) {
              kpi.growthRate = Math.round(kpi.growthRate * 100 + Number.EPSILON) / 100;
            }

            //conncted followup
            if (kpi.kpiCode == '202') {
              this.followup1 = kpi;
            }
            if (kpi.kpiCode == '203') {
              this.followup2 = kpi;
            }

            //booking followup
            if (kpi.kpiCode == '1-2') {
              this.bFollowup1 = kpi;
            }
            if (kpi.kpiCode == '1-3') {
              this.bFollowup2 = kpi;
            }
            if (kpi.kpiCode == '113') {
              this.bFollowup3 = kpi;
            }

            //conversion
            if (kpi.kpiCode == '111') {
              this.sameDay = kpi;
            }
            if (kpi.kpiCode == '222') {
              this.eventual = kpi;
            }

            //not connected reason
            if (kpi.kpiCode == '205') {
              this.noResponse = kpi;
            }
            if (kpi.kpiCode == '206') {
              this.busy = kpi;
            }
            if (kpi.kpiCode == '207') {
              this.switchOff = kpi;
            }
            if (kpi.kpiCode == '208') {
              this.invalid = kpi;
            }
            if (kpi.kpiCode == '209') {
              this.others = kpi;
            }

            //connected mo service
            if (kpi.kpiCode == '308') {
              this.wrongOdo = kpi;
            }
            if (kpi.kpiCode == '309') {
              this.alreadyService = kpi;
            }
            if (kpi.kpiCode == '310') {
              this.vehicleSold = kpi;
            }
            if (kpi.kpiCode == '311') {
              this.disPreviousSer = kpi;
            }
            if (kpi.kpiCode == '312') {
              this.distanceDealer = kpi;
            }
            if (kpi.kpiCode == '314') {
              this.disInsurance = kpi;
            }
            if (kpi.kpiCode == '313') {
              this.disSales = kpi;
            }
            if (kpi.kpiCode == '315') {
              this.contactedOthers = kpi;
            }
            if (kpi.kpiCode == '316') {
              this.custNotInterested = kpi;
            }
            if (kpi.kpiCode == '317') {
              this.dnd = kpi;
            }

            //booking no service
            if (kpi.kpiCode == '8-8') {
              this.bWrongOdo = kpi;
            }
            if (kpi.kpiCode == '8-9') {
              this.bAlreadyService = kpi;
            }
            if (kpi.kpiCode == '8-0') {
              this.bVehicleSold = kpi;
            }
            if (kpi.kpiCode == '8-1') {
              this.bDisPreviousSer = kpi;
            }
            if (kpi.kpiCode == '8-2') {
              this.bDistanceDealer = kpi;
            }
            if (kpi.kpiCode == '8-4') {
              this.bDisInsurance = kpi;
            }
            if (kpi.kpiCode == '8-3') {
              this.bDisSales = kpi;
            }
            if (kpi.kpiCode == '8-5') {
              this.bookingOthers = kpi;
            }
            if (kpi.kpiCode == '8-6') {
              this.bCustNotInterested = kpi;
            }
            if (kpi.kpiCode == '8-7') {
              this.bDnd = kpi;
            }
          });

          //barChart1 start not connected reason
          this.noResponse.actualVal = this.noResponse.actualVal || 0;
          this.busy.actualVal = this.busy.actualVal || 0;
          this.switchOff.actualVal = this.switchOff.actualVal || 0;
          this.invalid.actualVal = this.invalid.actualVal || 0;
          this.others.actualVal = this.others.actualVal || 0;
          let maxNotConnected = Math.max(this.noResponse.actualVal, this.busy.actualVal, this.switchOff.actualVal, this.invalid.actualVal, this.others.actualVal);
          if (maxNotConnected) {
            this.barChart1Options.scales.xAxes[0].ticks.max = maxNotConnected;
            this.barChart1Options.scales.yAxes[0].ticks.max = maxNotConnected;
            this.barChart1Data = [
              {
                data: [this.noResponse.actualVal, this.busy.actualVal, this.switchOff.actualVal, this.invalid.actualVal, this.others.actualVal],
                backgroundColor: 'rgb(87, 174, 239)',
                hoverBackgroundColor: 'rgb(87, 174, 239)',
                borderSkipped: 'chartArea',
                barPercentage: 0.5,
                barThickness: 20,
                maxBarThickness: 20,
                minBarLength: 2
              }
            ];
          }
          //barChart1 end

          //barChart1 start conversion
          this.sameDay.actualVal = this.sameDay.actualVal || 0;
          this.eventual.actualVal = this.eventual.actualVal || 0;
          if (this.sameDay.actualVal || this.eventual.actualVal) {
            this.barChart2Options.scales.xAxes[0].ticks.max = this.eventual.actualVal > this.sameDay.actualVal ? this.eventual.actualVal : this.sameDay.actualVal;
            this.barChart2Options.scales.yAxes[0].ticks.max = this.eventual.actualVal > this.sameDay.actualVal ? this.eventual.actualVal : this.sameDay.actualVal;
            this.barChart2Data = [
              {
                data: [this.sameDay.actualVal, this.eventual.actualVal],
                backgroundColor: ['rgb(46, 54, 104)', 'rgb(87, 174, 239)'],
                hoverBackgroundColor: ['rgb(46, 54, 104)', 'rgb(87, 174, 239)'],
                borderSkipped: 'chartArea',
                barPercentage: 0.5,
                barThickness: 20,
                maxBarThickness: 20,
                minBarLength: 2
              }
            ];
          }
          //barChart1 end

          //horizontalBarChart4 start noservice connected
          this.wrongOdo.actualVal = this.wrongOdo.actualVal || 0;
          this.alreadyService.actualVal = this.alreadyService.actualVal || 0;
          this.vehicleSold.actualVal = this.vehicleSold.actualVal || 0;
          this.disPreviousSer.actualVal = this.disPreviousSer.actualVal || 0;
          this.distanceDealer.actualVal = this.distanceDealer.actualVal || 0;
          this.disSales.actualVal = this.disSales.actualVal || 0;
          this.disInsurance.actualVal = this.disInsurance.actualVal || 0;
          this.contactedOthers.actualVal = this.contactedOthers.actualVal || 0;
          this.custNotInterested.actualVal = this.custNotInterested.actualVal || 0;
          this.dnd.actualVal = this.dnd.actualVal || 0;
          let max4 = Math.max(this.wrongOdo.actualVal, this.alreadyService.actualVal, this.vehicleSold.actualVal,
            this.disPreviousSer.actualVal, this.distanceDealer.actualVal, this.disSales.actualVal,
            this.disInsurance.actualVal, this.contactedOthers.actualVal, this.custNotInterested.actualVal,
            this.dnd.actualVal);
          if (max4) {
            this.horizontalBarChart4Options.scales.xAxes[0].ticks.max = max4 + 10;
            this.horizontalBarChart4Options.scales.yAxes[0].ticks.max = max4 + 10;
            this.horizontalBarChart4Data = [
              {
                data: [this.wrongOdo.actualVal, this.alreadyService.actualVal, this.vehicleSold.actualVal,
                this.disPreviousSer.actualVal, this.distanceDealer.actualVal, this.disSales.actualVal,
                this.disInsurance.actualVal, this.contactedOthers.actualVal, this.custNotInterested.actualVal,
                this.dnd.actualVal],
                backgroundColor: 'rgb(46, 54, 104)',
                hoverBackgroundColor: 'rgb(46, 54, 104)',
                borderSkipped: 'chartArea',
                barPercentage: 0.5,
                barThickness: 10,
              }
            ];
          }
          //horizontalBarChart4 start

          //horizontalBarChart5 start noservice booking
          this.bWrongOdo.actualVal = this.bWrongOdo.actualVal || 0;
          this.bAlreadyService.actualVal = this.bAlreadyService.actualVal || 0;
          this.bVehicleSold.actualVal = this.bVehicleSold.actualVal || 0;
          this.bDisPreviousSer.actualVal = this.bDisPreviousSer.actualVal || 0;
          this.bDistanceDealer.actualVal = this.bDistanceDealer.actualVal || 0;
          this.bDisSales.actualVal = this.bDisSales.actualVal || 0;
          this.bDisInsurance.actualVal = this.bDisInsurance.actualVal || 0;
          this.bookingOthers.actualVal = this.bookingOthers.actualVal || 0;
          this.bCustNotInterested.actualVal = this.bCustNotInterested.actualVal || 0;
          this.bDnd.actualVal = this.bDnd.actualVal || 0;
          let max5 = Math.max(this.bWrongOdo.actualVal, this.bAlreadyService.actualVal, this.bVehicleSold.actualVal,
            this.bDisPreviousSer.actualVal, this.bDistanceDealer.actualVal, this.bDisSales.actualVal,
            this.bDisInsurance.actualVal, this.bookingOthers.actualVal, this.bCustNotInterested.actualVal,
            this.bDnd.actualVal);
          if (max5) {
            this.horizontalBarChart5Options.scales.xAxes[0].ticks.max = max5 + 10;
            this.horizontalBarChart5Options.scales.yAxes[0].ticks.max = max5 + 10;
            this.horizontalBarChart5Data = [
              {
                data: [this.bWrongOdo.actualVal, this.bAlreadyService.actualVal, this.bVehicleSold.actualVal,
                this.bDisPreviousSer.actualVal, this.bDistanceDealer.actualVal, this.bDisSales.actualVal,
                this.bDisInsurance.actualVal, this.bookingOthers.actualVal, this.bCustNotInterested.actualVal,
                this.bDnd.actualVal],
                backgroundColor: 'rgb(46, 54, 104)',
                hoverBackgroundColor: 'rgb(46, 54, 104)',
                borderSkipped: 'chartArea',
                barPercentage: 0.5,
                barThickness: 10,
              }
            ];
          }
          //horizontalBarChart7 start followup connected
          this.followup1.actualVal = this.followup1.actualVal || 0;
          this.followup2.actualVal = this.followup2.actualVal || 0;
          if (this.followup1.actualVal || this.followup2.actualVal) {
            this.horizontalBarChart7Options.scales.xAxes[0].ticks.max = (this.followup1.actualVal + this.followup2.actualVal + 10) || this.followup.actualVal;
            this.horizontalBarChart7Options.scales.yAxes[0].ticks.max = (this.followup1.actualVal + this.followup2.actualVal + 10) || this.followup.actualVal;
            this.horizontalBarChart7Data = [
              {
                data: [this.followup1.actualVal, this.followup2.actualVal],
                backgroundColor: 'rgb(46, 54, 104)',
                hoverBackgroundColor: 'rgb(46, 54, 104)',
                borderSkipped: 'chartArea',
                barPercentage: 0.5,
                barThickness: 10,
              }
            ];
          }

          //horizontalBarChart8 start booking connected
          this.bFollowup1.actualVal = this.bFollowup1.actualVal || 0;
          this.bFollowup2.actualVal = this.bFollowup2.actualVal || 0;
          this.bFollowup3.actualVal = this.bFollowup3.actualVal || 0;
          if (this.bFollowup1.actualVal || this.bFollowup2.actualVal || this.bFollowup3.actualVal) {
            this.horizontalBarChart8Options.scales.xAxes[0].ticks.max = (this.bFollowup1.actualVal + this.bFollowup2.actualVal + this.bFollowup3.actualVal + 5) || this.followup.actualVal;
            this.horizontalBarChart8Options.scales.yAxes[0].ticks.max = (this.bFollowup1.actualVal + this.bFollowup2.actualVal + this.bFollowup3.actualVal + 5) || this.followup.actualVal;
            this.horizontalBarChart8Data = [
              {
                data: [this.bFollowup1.actualVal, this.bFollowup2.actualVal, this.bFollowup3.actualVal],
                backgroundColor: 'rgb(46, 54, 104)',
                hoverBackgroundColor: 'rgb(46, 54, 104)',
                borderSkipped: 'chartArea',
                barPercentage: 0.5,
                barThickness: 10,
              }
            ];
          }
          this.updateChartCard = false;
          this.spinner = false;
        } else {
          this.toastr.info(res["message"]);
          this.spinner = false;
          this.updateChartCard = false;
        }
      }, err => {
        this.spinner = false;
        this.updateChartCard = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
      });
  }

  /**
   * Name: getDashboardKpiCard
   * purpose: To get left kpi card history
   */
  getDashboardKpiCard(): void {
    this.spinner = true;
    let selectedCre = '';
    this.selectedCre.forEach((element, index) => {
      if (index == 0) {
        selectedCre = element;
      } else {
        selectedCre = selectedCre + ',' + element;
      }
    });
    let selectedWorkShop = '';
    this.selectedKpiCardWorkShop.forEach((element, index) => {
      if (index == 0) {
        selectedWorkShop = element.split(" - ")[0];
      } else {
        selectedWorkShop = selectedWorkShop + ',' + element.split(" - ")[0];
      }
    });

    let service = '';
    if(this.selectService.value.selectServiceType != ""){
      this.selectService.value.selectServiceType.forEach((element,index)=>{
        if(element == "0"){
          this.selectService.value.selectServiceType.splice(index,1);
        }
      });
      service = this.selectService.value.selectServiceType.toString();
    }

    const request = {
      "userId": this.userInfo.userId,
      "roleId": this.userInfo.roleId,
      "creId": selectedCre || '',
      "workshopCode": selectedWorkShop || '',
      "service": service ? service.toString() : '',
      "month": new Date(this.maxDate).getMonth() + 1,
      "year": new Date(this.maxDate).getFullYear()
    };
    this.resetKpiCard();
    this.commonService.getDashboardKpiCard(request).subscribe(
      res => {
        if (res["responseCode"] == 0) {
          let mnth = new Date(this.maxDate).getMonth() + 1;
          this.callCoverage = [];
          this.avgCall = [];
          this.successReminder = [];
          this.successVisit = [];
          this.successNoShow = [];
          this.lostConversion = [];
          this.overAllConversion = [];
          this.bookingRate = [];
          this.perCallConversion = [];

          res["responseData"].forEach(kpi => {
            if (kpi.actualVal) {
              kpi.actualVal = Math.round(kpi.actualVal * 100 + Number.EPSILON) / 100;
            }
            if (kpi.growthRate) {
              kpi.growthRate = Math.round(kpi.growthRate * 100 + Number.EPSILON) / 100;
            }
            if (kpi.kpiCode == '013') {
              this.callCoverage.push(kpi);
              this.selectedCallCoverage = (mnth == kpi.monthVal) ? kpi : {};
            }
            if (kpi.kpiCode == '014') {
              this.avgCall.push(kpi);
              this.selectedAvgCall = (mnth == kpi.monthVal) ? kpi : {};
            }
            if (kpi.kpiCode == '015') {
              this.successReminder.push(kpi);
              this.selectedSuccessReminder = (mnth == kpi.monthVal) ? kpi : {};
            }
            if (kpi.kpiCode == '016') {
              this.successVisit.push(kpi);
              this.selectedSuccessVisit = (mnth == kpi.monthVal) ? kpi : {};
            }
            if (kpi.kpiCode == '017') {
              this.successNoShow.push(kpi);
              this.selectedSuccessNoShow = (mnth == kpi.monthVal) ? kpi : {};
            }
            if (kpi.kpiCode == '018') {
              this.lostConversion.push(kpi);
              this.selectedLostConversion = (mnth == kpi.monthVal) ? kpi : {};
            }
            if (kpi.kpiCode == '019') {
              this.overAllConversion.push(kpi);
              this.selectedOverAllConversion = (mnth == kpi.monthVal) ? kpi : {};
            }
            if (kpi.kpiCode == '020') {
              this.bookingRate.push(kpi);
              this.selectedBookingRate = (mnth == kpi.monthVal) ? kpi : {};
            }
            if (kpi.kpiCode == '023') {
              this.perCallConversion.push(kpi);
              this.selectedPerCallConversion = (mnth == kpi.monthVal) ? kpi : {};
            }
          });
          this.spinner = false;
        } else {
          this.toastr.info(res["message"]);
          this.spinner = false;
        }
      }, err => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
      });
  }

  /**
   * Name: getDashboardKpi
   * purpose: To get dashboard kpi
   */
  getDashboardKpi(): void {
    if (this.isDateRangeInvalid) {
      this.toastr.error("Please select dates within a 30-day range to proceed.", "Error");
      return;
    }
    this.spinner = true;
    this.updateChart = true;
    let selectedCre = '';
    this.selectedCre.forEach((element, index) => {
      if (index == 0) {
        selectedCre = element;
      } else {
        selectedCre = selectedCre + ',' + element;
      }
    });
    let selectedWorkShop = '';
    this.selectedWorkShop.forEach((element, index) => {
      if (index == 0) {
        selectedWorkShop = element.split(" - ")[0];
      } else {
        selectedWorkShop = selectedWorkShop + ',' + element.split(" - ")[0];
      }
    });

    let service = '';
    if(this.selectService.value.selectServiceType != ""){
      this.selectService.value.selectServiceType.forEach((element,index)=>{
        if(element == "0"){
          this.selectService.value.selectServiceType.splice(index,1);
        }
      });
      service = this.selectService.value.selectServiceType.toString();
    }

    const request = {
      "userId": this.userInfo.userId,
      "roleId": this.userInfo.roleId,
      "creId": selectedCre || '',
      "workshopCode": selectedWorkShop || '',
      "service": service ? service.toString() : '',
      "startDate": this.datePipe.transform(this.fromDate, "yyyy-MM-dd").toString(),
      "endDate": this.datePipe.transform(this.toDate, "yyyy-MM-dd").toString()
    };
    this.resetDashboard();
    this.commonService.getDashboardKpi(request).subscribe(
      res => {
        if (res["responseCode"] == 0) {
          this.selectedDate = this.datePipe.transform(this.date.value['_d'], "MMM yy");
          res["responseData"].forEach(kpi => {
            if (kpi.actualVal) {
              kpi.actualVal = Math.round(kpi.actualVal * 100 + Number.EPSILON) / 100;
            }
            if (kpi.growthRate) {
              kpi.growthRate = Math.round(kpi.growthRate * 100 + Number.EPSILON) / 100;
            }
            if (kpi.kpiCode == '001') {
              this.allocated = kpi;
            }
            if (kpi.kpiCode == '002') {
              this.attempted = kpi;
            }
            if (kpi.kpiCode == '003') {
              this.notAttempted = kpi;
            }
            if (kpi.kpiCode == '004') {
              this.contacted = kpi;
            }
            if (kpi.kpiCode == '005') {
              this.notContacted = kpi;
            }
            if (kpi.kpiCode == '006') {
              this.booking = kpi;
            }
            if (kpi.kpiCode == '011') {
              this.converted = kpi;
            }
            if (kpi.kpiCode == '022') {
              this.activeBooking = kpi;
            }
            if (kpi.kpiCode == '007') {
              this.contactedNoService = kpi;
            }
            if (kpi.kpiCode == '008') {
              this.contactedFollowup = kpi;
            }
            if (kpi.kpiCode == '021') {
              this.connectedSystemClose = kpi;
            }
            if (kpi.kpiCode == '009') {
              this.bookingNoService = kpi;
            }
            if (kpi.kpiCode == '010') {
              this.bookingFollowup = kpi;
            }
            if (kpi.kpiCode == '024') {
              this.bookingSystemClose = kpi;
            }
          });
          if(this.allocated.actualVal != 0) {
            this.AttemptedAchievement = (this.attempted.actualVal/this.allocated.actualVal)*100;
          } else {
            this.AttemptedAchievement = 0;
          }
          if(this.attempted.actualVal != 0) {
            this.ContactedAchievement = (this.contacted.actualVal/this.attempted.actualVal)*100;
          } else {
            this.ContactedAchievement = 0;
          }
          if(this.contacted.actualVal != 0) {
            this.BookingsAchievement = (this.booking.actualVal/this.contacted.actualVal)*100;
          } else {
            this.BookingsAchievement = 0;
          }

          //horizontalBarChart1 start
          this.contacted.actualVal = this.contacted.actualVal || 0;
          this.notContacted.actualVal = this.notContacted.actualVal || 0;
          if (this.contacted.actualVal || this.notContacted.actualVal) {
            this.horizontalBarChart1Data = [
              {
                data: [this.contacted.actualVal],
                stack: 'a',
                label: 'Contacted',
                backgroundColor: 'rgb(46, 54, 104)',
                hoverBackgroundColor: 'rgb(46, 54, 104)',
                borderSkipped: 'chartArea',
                barPercentage: 0.5,
                barThickness: 12,
                maxBarThickness: 12,
                minBarLength: 2
              },
              {
                data: [this.notContacted.actualVal],
                stack: 'a',
                label: 'Not Contacted',
                backgroundColor: 'rgb(87, 174, 239)',
                hoverBackgroundColor: 'rgb(87, 174, 239)',
                borderSkipped: 'chartArea',
                barPercentage: 0.5,
                barThickness: 12,
                maxBarThickness: 12,
                minBarLength: 2
              }
            ];
            let max1 = this.contacted.actualVal + this.notContacted.actualVal;
            this.horizontalBarChart1Options.scales.xAxes[0].ticks.max = max1;
            this.horizontalBarChart1Options.scales.yAxes[0].ticks.max = max1;
          }
          //horizontalBarChart1 end

          //horizontalBarChart2 start
          this.booking.actualVal = this.booking.actualVal || 0;
          this.contactedFollowup.actualVal = this.contactedFollowup.actualVal || 0;
          this.connectedSystemClose.actualVal = this.connectedSystemClose.actualVal || 0;
          this.contactedNoService.actualVal = this.contactedNoService.actualVal || 0;
          let max2 = this.booking.actualVal + this.contactedFollowup.actualVal + this.connectedSystemClose.actualVal + this.contactedNoService.actualVal;
          if (max2) {
            this.horizontalBarChart2Options.scales.xAxes[0].ticks.max = max2;
            this.horizontalBarChart2Options.scales.yAxes[0].ticks.max = max2;
            this.horizontalBarChart2Data = [
              {
                data: [this.booking.actualVal],
                stack: 'a',
                label: 'Booking',
                backgroundColor: '#4834d4',
                hoverBackgroundColor: '#4834d4',
                borderSkipped: 'chartArea',
                barPercentage: 0.5,
                barThickness: 12,
                maxBarThickness: 12,
                minBarLength: 2
              },
              {
                data: [this.contactedFollowup.actualVal],
                stack: 'a',
                label: 'Followup',
                backgroundColor: '#57aeef',
                hoverBackgroundColor: '#57aeef',
                borderSkipped: 'chartArea',
                barPercentage: 0.5,
                barThickness: 12,
                maxBarThickness: 12,
                minBarLength: 2
              },
              {
                data: [this.connectedSystemClose.actualVal],
                stack: 'a',
                label: 'System Closed',
                backgroundColor: '#5758bb',
                hoverBackgroundColor: '#5758bb',
                borderSkipped: 'chartArea',
                barPercentage: 0.5,
                barThickness: 12,
                maxBarThickness: 12,
                minBarLength: 2
              },
              {
                data: [this.contactedNoService.actualVal],
                stack: 'a',
                label: 'No Service',
                backgroundColor: '#2e3668',
                hoverBackgroundColor: '#2e3668',
                borderSkipped: 'chartArea',
                barPercentage: 0.5,
                barThickness: 12,
                maxBarThickness: 12,
                minBarLength: 2
              }
            ];
          }
          //horizontalBarChart2 end

          //horizontalBarChart3 start
          this.activeBooking.actualVal = this.activeBooking.actualVal || 0;
          this.converted.actualVal = this.converted.actualVal || 0;
          this.bookingFollowup.actualVal = this.bookingFollowup.actualVal || 0;
          this.bookingNoService.actualVal = this.bookingNoService.actualVal || 0;
          this.bookingSystemClose.actualVal = this.bookingSystemClose.actualVal || 0;
          let max3 = this.activeBooking.actualVal + this.converted.actualVal + this.bookingFollowup.actualVal + this.bookingNoService.actualVal;
          if (max3) {
            this.horizontalBarChart3Options.scales.xAxes[0].ticks.max = max3;
            this.horizontalBarChart3Options.scales.yAxes[0].ticks.max = max3;
            this.horizontalBarChart3Data = [
              {
                data: [this.activeBooking.actualVal],
                stack: 'a',
                label: 'Active',
                backgroundColor: '#2e3668',
                hoverBackgroundColor: '#2e3668',
                borderSkipped: 'chartArea',
                barPercentage: 0.5,
                barThickness: 12,
                maxBarThickness: 12,
                minBarLength: 2
              },

              {
                data: [this.bookingNoService.actualVal],
                stack: 'a',
                label: 'No Service',
                backgroundColor: '#4834d4',
                hoverBackgroundColor: '#4834d4',
                borderSkipped: 'chartArea',
                barPercentage: 0.5,
                barThickness: 12,
                maxBarThickness: 12,
                minBarLength: 2
              },
              {
                data: [this.bookingFollowup.actualVal],
                stack: 'a',
                label: 'Followup',
                backgroundColor: '#57aeef',
                hoverBackgroundColor: '#57aeef',
                borderSkipped: 'chartArea',
                barPercentage: 0.5,
                barThickness: 12,
                maxBarThickness: 12,
                minBarLength: 2
              },
              {
                data: [this.converted.actualVal],
                stack: 'a',
                label: 'Converted',
                backgroundColor: '#3f729d',
                hoverBackgroundColor: '#3f729d',
                borderSkipped: 'chartArea',
                barPercentage: 0.5,
                barThickness: 12,
                maxBarThickness: 12,
                minBarLength: 2
              }
            ];
          }
          //horizontalBarChart3 end
          this.updateChart = false;
          this.getDashboardResponseKpi();
          this.getDashboardServiceKpi();
          this.spinner = false;
        } else {
          this.toastr.info(res["message"]);
          this.spinner = false;
          this.updateChart = false;
        }
      }, err => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
        this.updateChart = false;
      });
  }

  /**
   * Name: getDashboardServiceKpi
   * purpose: To get service breakup
   */
  getDashboardServiceKpi(): void {
    this.spinner = true;
    let selectedCre = '';
    this.selectedCre.forEach((element, index) => {
      if (index == 0) {
        selectedCre = element;
      } else {
        selectedCre = selectedCre + ',' + element;
      }
    });
    let selectedWorkShop = '';
    this.selectedWorkShop.forEach((element, index) => {
      if (index == 0) {
        selectedWorkShop = element.split(" - ")[0];
      } else {
        selectedWorkShop = selectedWorkShop + ',' + element.split(" - ")[0];
      }
    });

    let service = '';
    if(this.selectService.value.selectServiceType != ""){
      this.selectService.value.selectServiceType.forEach((element,index)=>{
        if(element == "0"){
          this.selectService.value.selectServiceType.splice(index,1);
        }
      });
      service = this.selectService.value.selectServiceType.toString();
    }

    const request = {
      "userId": this.userInfo.userId,
      "roleId": this.userInfo.roleId,
      "creId": selectedCre || '',
      "workshopCode": selectedWorkShop || '',
      "service": service ? service.toString() : '',
      "startDate": this.datePipe.transform(this.fromDate, "yyyy-MM-dd").toString(),
      "endDate": this.datePipe.transform(this.toDate, "yyyy-MM-dd").toString()
    };
    this.commonService.getDashboardServiceKpi(request).subscribe(
      res => {
        if (res["responseCode"] == 0) {
          this.allocatedServiceBreak = [];
          this.attemptedServiceBreak = [];
          this.connectedServiceBreak = [];
          this.bookingServiceBreak = [];
          res["responseData"].forEach(element => {
            if (element.kpiCode == '001') {
              this.allocatedServiceBreak.push(element);
            }
            if (element.kpiCode == '002') {
              this.attemptedServiceBreak.push(element);
            }
            if (element.kpiCode == '004') {
              this.connectedServiceBreak.push(element);
            }
            if (element.kpiCode == '006') {
              this.bookingServiceBreak.push(element);
            }
          });
          this.spinner = false;
        } else {
          this.toastr.info(res["message"]);
          this.spinner = false;
        }
      }, err => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
      });
  }

  /**
   * Name: filterDashboard
   * purpose: To get filter Dashboard
   */
  filterDashboard(): void {
    this.spinner = true;
    let workshopSet = new Set<string>();
    let workshopCardSet = new Set<string>();
    this.commonService.filterDashboard(this.userInfo).subscribe(
      res => {
        if (res["responseCode"] == 0) {
          this.filtersWorkshop = [];
          this.filtersCre = [];
          res['responseData'].forEach(element => {
            let workshopCode = element.workshop.split(" - ")[0];
            let workshop = { id: element.id, workshopCode: workshopCode, workshop: element.workshop };
            let cre = element.creId;
            this.filtersWorkshop.push(workshop);
            workshopSet.add(workshop.workshop);
            workshopCardSet.add(workshop.workshop);
            if (!this.filtersCre.includes(cre)) {
              this.filtersCre.push(cre);
            }
          });
          this.uniqueWorkshop = Array.from(workshopSet);
          this.uniqueWorkshopCard = Array.from(workshopCardSet);
          this.uniqueWorkshopCopy = this.uniqueWorkshop;
          this.uniqueWorkshopCardCopy = this.uniqueWorkshopCard;
          this.filtersCreCopy = this.filtersCre;
          this.spinner = false;
        } else {
          this.spinner = false;
        }
      }, err => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
      });
  }

  /**
   * Name: periodFilter
   * purpose: To get filter Dashboard
   */
  periodFilter(): void {
    this.spinner = true;
    this.commonService.periodFilter(this.userInfo).subscribe(
      res => {
        if (res["responseCode"] == 0) {
          if (res['responseData'].length) {
            let dateFilter = res['responseData'][0];
            if(dateFilter.minMonth && dateFilter.minYear) {
              this.minDate = new Date(res['responseData'][0].minMonth + '/' + '1/' + res['responseData'][0].minYear);
            } else {
              this.minDate = new Date();
            }
            if(dateFilter.maxMonth && dateFilter.maxYear) {
              this.maxDate = new Date(res['responseData'][0].maxMonth + '/' + '1/' + res['responseData'][0].maxYear);
            } else {
              this.maxDate = new Date();
            }
            let date = moment(this.maxDate);
            this.date.setValue(date);
            if(dateFilter.minMonth && dateFilter.minYear && dateFilter.maxMonth && dateFilter.maxYear) {
              this.selectedDate = this.datePipe.transform(this.date.value['_d'], "MMM yy");
              this.getDashboardServiceKpi();
              this.getDashboardKpiCard();
              this.getDashboardKpi();
            } else {
              this.toastr.info("Data not found.");
            }
          } else {
            this.minDate = new Date();
            this.maxDate = new Date();
          }
          this.spinner = false;
        } else {
          this.toastr.info(res["message"]);
          this.spinner = false;
        }
      }, err => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
      });
  }

  onKeyWorkshop() : void {
    this.uniqueWorkshop = this.uniqueWorkshopCopy;
    this.dealerCode = [];
    this.selectedDealer = this.selectedDealer.trim();
    this.dealerCode = this.uniqueWorkshop.filter(item =>
      item.toLowerCase().includes(this.selectedDealer.toLowerCase())
    );
    this.dealerCode.forEach(element => {
      let index = this.uniqueWorkshopCopy.findIndex((ele) => {return ele == element});
      if(index != -1) {
        this.uniqueWorkshopCopy.splice(index, 1);
      }
      this.uniqueWorkshopCopy.unshift(element);
    })
    if(this.dealerCode.length > 0) {
      this.closeInput();
    }
    this.uniqueWorkshop = [];
    this.uniqueWorkshop = this.uniqueWorkshopCopy;
  }

  closeInput() : void {
    if(this.dealerCode.length == 0) {
     this.selectedDealer = '';
     this.uniqueWorkshop = this.uniqueWorkshopCopy;
    }
  }

  onKeyCRE() : void {
    this.filtersCre = this.filtersCreCopy;
    this.creCode = [];
    this.selectedCreCode = this.selectedCreCode.trim();
    this.creCode = this.filtersCre.filter(item =>
      item.toLowerCase().includes(this.selectedCreCode.toLowerCase())
    );
    this.creCode.forEach(element => {
      let index = this.filtersCreCopy.findIndex((ele) => {return ele == element});
      if(index != -1) {
        this.filtersCreCopy.splice(index, 1);
      }
      this.filtersCreCopy.unshift(element);
    })
    if(this.creCode.length > 0) {
      this.closeInputCre();
    }
    this.filtersCre = [];
    this.filtersCre = this.filtersCreCopy;
  }

  closeInputCre() : void {
    if(this.creCode.length == 0) {
     this.selectedCreCode = '';
     this.filtersCre = this.filtersCreCopy;
    }
  }

  onKeyWorkshopCard() : void {
    this.uniqueWorkshopCard = this.uniqueWorkshopCardCopy;
    this.dealerCodeCard = [];
    this.selectedCardDealer = this.selectedCardDealer.trim();
    this.dealerCodeCard = this.uniqueWorkshopCard.filter(item =>
      item.toLowerCase().includes(this.selectedCardDealer.toLowerCase())
    );
    this.dealerCodeCard.forEach(element => {
      let index = this.uniqueWorkshopCardCopy.findIndex((ele) => {return ele == element});
      if(index != -1) {
        this.uniqueWorkshopCardCopy.splice(index, 1);
      }
      this.uniqueWorkshopCardCopy.unshift(element);
    })

    if(this.dealerCodeCard.length > 0) {
      this.closeInput();
    }
    this.uniqueWorkshopCard = [];
    this.uniqueWorkshopCard = this.uniqueWorkshopCardCopy;
  }

  closeInputCard() : void {
    if(this.dealerCodeCard.length == 0) {
     this.selectedCardDealer = '';
     this.uniqueWorkshopCard = this.uniqueWorkshopCardCopy;
    }
  }

  /**
  * Name: getDashboardReport
  * purpose: To export report as excel
  */
  getDashboardReport(): void {
    if (this.isDateRangeInvalid) {
      this.toastr.error("Please select dates within a 30-day range to proceed.", "Error");
      return;
    }
    this.spinner = true;
    //this.updateChart = true;
    let selectedCre = '';
    this.selectedCre.forEach((element, index) => {
      if (index == 0) {
        selectedCre = element;
      } else {
        selectedCre = selectedCre + ',' + element;
      }
    });
    let selectedWorkShop = '';
    this.selectedWorkShop.forEach((element, index) => {
      if (index == 0) {
        selectedWorkShop = element.split(" - ")[0];
      } else {
        selectedWorkShop = selectedWorkShop + ',' + element.split(" - ")[0];
      }
    });

    let serviceType = '';
    if(this.selectService.value.selectServiceType != ""){
      this.selectService.value.selectServiceType.forEach((element,index)=>{
        if(element == "0"){
          this.selectService.value.selectServiceType.splice(index,1);
        }
      });
      serviceType = this.selectService.value.selectServiceType.toString();
    }

    let startDate = this.datePipe.transform(this.fromDate, "yyyy-MM-dd").toString();
    let endDate = this.datePipe.transform(this.toDate, "yyyy-MM-dd").toString();
    let fileName = "Dashboard Report_For_" + startDate + "-" + endDate ;
    this.commonService.getDashboardReport(this.userInfo.userId, this.userInfo.roleId, selectedCre, startDate, endDate, serviceType, selectedWorkShop)
    .subscribe(fileData => {
      if (fileData) {
        const blob: any = new Blob([fileData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        let link = document.createElement("a");
        if (link.download !== undefined) {
          let url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.spinner = false;
        }
      } else {
        this.spinner = false;
      }
    }, err => {
      this.spinner = false;

    });
  }

  tosslePerOne(all){
    if (this.allSelectedService.selected) {
     this.allSelectedService.deselect();
     return false;
    }
    if (this.selectService.controls.selectServiceType.value.length==this.services.length)
     this.allSelectedService.select();
 }

   toggleAllSelection() {
      if (this.allSelectedService.selected) {
        this.selectService.controls.selectServiceType
         .patchValue([...this.services.map(item => item.key), 0]);
         this.selectAllService = true;
      } else {
        this.selectService.controls.selectServiceType.patchValue([]);
      }
   }

   dashboardSelection(){
    if(this.selectedDashboard == 'Prs-Dashboard'){
   //this.showPrsDashboard=true
     this.router.navigate(["prs-dashboard"])
    }
   }

  setDefaultDates() {
    const current = new Date();
    this.fromDate = new Date(current.getFullYear(), current.getMonth(), 1); // 1st of current month
    this.toDate = this.today; // Today's date
  }

  // Validate the date range to restrict to 30 days
  validateDateRange(type: 'from' | 'to') {
    const thirtyDaysInMs = 30 * 24 * 60 * 60 * 1000;
    this.isDateRangeInvalid = false;
    if (type === 'from') {
      const maxToDate = new Date(this.fromDate.getTime() + thirtyDaysInMs);
      if (this.toDate.getTime() > maxToDate.getTime()) {
        this.isDateRangeInvalid = true;
      } else {
        this.isDateRangeInvalid = false;
      }
    } else if (type === 'to') {
      const minFromDate = new Date(this.toDate.getTime() - thirtyDaysInMs);
      if (this.fromDate.getTime() < minFromDate.getTime()) {
        this.isDateRangeInvalid = true;
      } else {
        this.isDateRangeInvalid = false;
      }
    }
  }
}